export const FIELD_TEXT_FILTER = "textFilter";
export const FIELD_JOB_FILTER = "jobFilter";
export const FIELD_DATE_FROM = "dateFrom";
export const FIELD_DATE_TO = "dateTo";
